import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TappableCard from '../common/TappableCard';
import BlueSlab from '../../images/newInsurerPage/blueSlab.svg';
import BrowSlab from '../../images/newInsurerPage/brownSlab.svg';
import ManIcon from '../../images/newInsurerPage/menIcon.svg';
import CalenderIcon from '../../images/newInsurerPage//calenderIcon.svg';
import testDocIcon from '../../images/hash.svg';
import OrangeSlab from '../../images/newInsurerPage/orangeSlab.svg';
import ReimbarsArrow from '../../images/newInsurerPage/claimsPageArrow.svg';
import WhiteArrow from '../../images/newInsurerPage/claimsPageWhiteArrow.svg';
import arrowRight from '../../images/common/arrow-right.svg';
import StatusProcessing from '../../images/consultations/processing.png';
import StatusCross from '../../images/consultations/cancelled.png';
import StatusTickGreen from '../../images/consultations/processed.png';
import StatusTick from '../../images/consultations/confirmed.png';
import UserIcon from '../../images/Claims-Page/User.svg';
import clockIcon from '../../images/Claims-Page/Check cr-fr.svg';

const OrderContainer = styled.div`
  border-radius: 12px !important;
  cursor: pointer;
  background: #fff;
  border: none;
  position: relative;
`;

// const ClaimsStatusCard = ({ orderRequest, onTap }) => {
//   return (
//     <OrderContainer
//       className="border border-boxCard rounded-12 px-20px pb-12px mb-20px"
//       onClick={onTap}
//     >
//       <div className="border-b border-txtsecondary-shades4 pb-12px">
//         <div className="flex justify-between items-center">
//           <div className="py-3px px-8px bg-secondary-shades8 self-start">
//             <p className="text-secondary-shades3 font-semibold text-chip">
//               {orderRequest.label}
//             </p>
//           </div>
//           <img
//             src={arrowRight}
//             alt="open order"
//             className="pt-14px pb-4px"
//             style={{ filter: 'brightness(0) saturate(100%)' }}
//           />
//         </div>
//         <div>
//           <div className="mb-2">
//             <p className="text-body-s text-sub">
//               CLAIM NO:{' '}
//               <span className="text-txtlight font-semibold">
//                 {orderRequest.claimInfo.claimId}
//               </span>
//             </p>
//           </div>
//           <div className="flex mb-2">
//             <img src={UserIcon} alt="stethoscope" />
//             <p className="font-medium text-body-s text-txtlight ml-8px">
//               {orderRequest.claimInfo.patientName}
//             </p>
//           </div>
//           <div className="flex justify-between">
//             <div className="flex">
//               <img src={clockIcon} alt="stethoscope" />
//               <p className="text-medium text-body-s text-txtlight ml-8px">
//                 {orderRequest.claimInfo.claimDate}
//               </p>
//             </div>
//             <div className="flex">
//               {orderRequest.claimInfo.status.icon === 'processing' ? (
//                 <img
//                   src={StatusProcessing}
//                   alt="status"
//                   style={{ height: '15px', width: '15px' }}
//                 />
//               ) : (
//                 ''
//               )}
//               {orderRequest.claimInfo.status.icon === 'cross' ? (
//                 <img
//                   src={StatusCross}
//                   alt="status"
//                   style={{ height: '15px', width: '15px' }}
//                 />
//               ) : (
//                 ''
//               )}
//               {orderRequest.claimInfo.status.icon === 'tick' &&
//               orderRequest.claimInfo.status.hex === '#1EB865' ? (
//                 <img
//                   src={StatusTickGreen}
//                   alt="status"
//                   style={{ width: '15px', height: '15px' }}
//                 />
//               ) : (
//                 ''
//               )}
//               {orderRequest.claimInfo.status.icon === 'tick' &&
//               orderRequest.claimInfo.status.hex !== '#1EB865' ? (
//                 <img
//                   src={StatusTick}
//                   alt="status"
//                   style={{ width: '15px', height: '15px' }}
//                 />
//               ) : (
//                 ''
//               )}
//               <p
//                 className="text-body-s font-semibold ml-4px"
//                 style={{ color: `${orderRequest.claimInfo.status.hex}` }}
//               >
//                 {orderRequest.claimInfo.status.label}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="flex justify-between items-center pt-12px">
//         <p className="text-body-s text-txtlight font-semibold">Claim Amount</p>
//         <p className="text-title-m text-txtlight font-semibold">
//           ₹ {orderRequest.claimInfo.claimAmount}
//         </p>
//       </div>
//     </OrderContainer>
//   );
// };

// ClaimsStatusCard.propTypes = {
//   onTap: PropTypes.func,
//   orderRequest: PropTypes.object.isRequired,
// };

// export default ClaimsStatusCard;
const getSlabs = (color) => {
  console.log('color is ', color);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="32"
      viewBox="0 0 6 32"
      fill="none"
    >
      <path
        d="M6 6C6 2.68629 3.31371 0 0 0V32C3.31371 32 6 29.3137 6 26V6Z"
        fill={color}
      />
    </svg>
  );
};
// const getTextColor = () => {};
// const getBckground = () => {};
// const getArrow = () => {};
// const getIcon = () => {};

const ClaimsStatusCard = ({ orderRequest, onTap }) => {
  return (
    <OrderContainer
      className="border border-boxCard rounded-12 mb-20px"
      onClick={onTap}
    >
      <HeaderContainer>
        <HeaderLeftContainer>
          {/* <img src={getSlabs(orderRequest.claimInfo.logoHex)} /> */}
          <StyledDiv
            style={{ background: orderRequest.claimInfo.logoHex }}
          ></StyledDiv>
          <HeaderLeft style={{ color: orderRequest.claimInfo.logoHex }}>
            {orderRequest.label}
          </HeaderLeft>
        </HeaderLeftContainer>
        <HeaderRight style={{ background: orderRequest.claimInfo.logoHex }}>
          {orderRequest.claimInfo.claimType}
          <img
            src={WhiteArrow}
            style={{
              display: 'inline',
              paddingLeft: '5px',
              height: '10px',
              width: '10px',
            }}
            alt=""
          />
        </HeaderRight>
      </HeaderContainer>
      <BodyContainer>
        <BodySubContainer>
          <BodyIcon>
            <img
              src={orderRequest.claimInfo.logoIcon}
              style={{
                width: '50px',
                background: orderRequest.claimInfo.logoHex,
                borderRadius: '10px',
              }}
              alt=""
            />
          </BodyIcon>
          <BodyText>
            <BodyStatus>{orderRequest.claimInfo.status.label}</BodyStatus>
            {orderRequest.claimInfo.centerName &&
              orderRequest.claimInfo.centerName !== 'null' && (
                <BodyTitle>{orderRequest.claimInfo.centerName}</BodyTitle>
              )}

            <BodyFlexDetails>
              <SingleDetail>
                <img src={ManIcon} alt="" height={20} width={20} />
                <SingleText>{orderRequest.claimInfo.patientName}</SingleText>
              </SingleDetail>
              <SingleDetail>
                <img src={CalenderIcon} alt="" height={20} width={20} />
                <SingleText>{orderRequest.claimInfo.claimDate}</SingleText>
              </SingleDetail>
              <SingleDetail>
                <img src={testDocIcon} alt="" height={15} width={15} />
                <SingleText>{orderRequest.claimInfo.claimId}</SingleText>
              </SingleDetail>
            </BodyFlexDetails>
            {orderRequest?.claimInfo?.tpaClaimId && (
              <SingleDetail fullWidth={true}>
                <img src={testDocIcon} alt="" />
                <SingleText>
                  TPA Claim ID: {orderRequest.claimInfo.tpaClaimId}
                </SingleText>
              </SingleDetail>
            )}
          </BodyText>
        </BodySubContainer>
      </BodyContainer>
      <FooterContainer>
        <SingleText>Total Amount</SingleText>
        <FooterRight>₹ {orderRequest.claimInfo.claimAmount}</FooterRight>
      </FooterContainer>
    </OrderContainer>
  );
};

const StyledDiv = styled.div`
  position: absoulte;
  width: 7px;
  height: 31px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
`;
const FooterRight = styled.p`
  color: var(--text-sub, #767787);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 18px */
  letter-spacing: 0.5px;
`;
const FooterContainer = styled.div`
  padding: 0.8rem;
  display: flex;
  justify-content: space-between;
`;
const SimpleFlex = styled.div`
  display: flex;
  justify-content: space-between;
`;

const HeaderContainer = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const HeaderLeftContainer = styled.div`
  display: flex;
  align-items: center;
`;
const HeaderLeft = styled.p`
  padding-left: 12px;
  color: #505fd9;
  width: 120px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`;
const HeaderRightContainer = styled.div`
  border-radius: 4px 0px 0px 4px;
  background: rgba(181, 168, 250, 0.2);
  display: flex;
  justify-content: center;
  align-item: center;
`;
const HeaderRight = styled.p`
  min-width: 80px;
  color: white;
  border-radius: 4px 0px 0px 4px;
  padding: 0.5rem;
  text-transform: capitalize;
  font-size: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
`;
const BodyContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #f2f2f2;
`;
const BodySubContainer = styled.div`
  display: flex;
  align-items: start;
  padding-top: 0.3rem;
`;
const BodyIcon = styled.div`
  display: flex;
  align-self: flex-start;
  padding-left: 1rem;
  padding-top: 0.6rem;
  padding-right: 0.3rem;
`;
const BodyText = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
`;

const BodyStatus = styled.p`
  color: #d37e2f;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 18px */
  letter-spacing: 0.5px;
`;
const BodyTitle = styled.p`
  color: var(--primary-text-new, #0f0b28);

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 220%; /* 19.6px */
  letter-spacing: 0.25px;
`;

const BodyFlexDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  margin-top: 10px;
  //  justify-content: space-between;
`;
const SingleDetail = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 120px;
  width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
  padding-top: 0.1rem;
  padding-bottom: 0.3rem;
`;
const SingleText = styled.div`
  padding-left: 5px;
  color: var(--text-sub, #767787);
  font-size: 12px;
  font-weight: 400;
  line-height: 150%; /* 18px */
  letter-spacing: 0.5px;
`;
ClaimsStatusCard.propTypes = {
  onTap: PropTypes.func,
  orderRequest: PropTypes.object.isRequired,
};

export default ClaimsStatusCard;
